import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export const useSystemAdmin = () => {
  const { user } = useAuth();

  const { data: isSystemAdmin, isLoading } = useQuery({
    queryKey: ['systemAdmin', user?.id],
    queryFn: async (): Promise<boolean> => {
      if (!user) return false;

      // Check if user exists in system_admins table
      const { data, error } = await supabase
        .from('system_admins')
        .select('id')
        .eq('user_id', user.id)
        .maybeSingle();

      if (error) {
        console.error('Error checking system admin status:', error);
        return false;
      }

      return !!data;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000,
  });

  return {
    isSystemAdmin: isSystemAdmin ?? false,
    isLoading,
  };
};
